/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

/** The clinic mark on the guest referral confirmation (ENH-052). Colour comes from `stroke`. */
function StethoscopeIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.stroke || '#FFFFFF';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11 2v2M5 2v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 15a6 6 0 0 0 12 0v-3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="20" cy="10" r="2" stroke={color} strokeWidth="2" />
    </svg>
  );
}

export default StethoscopeIcon;
